import { useCallback } from "react";
import { UrlObject } from "url";

import { buildLocalizedUrl } from "helpers";
import { useCountry } from "./useCountry";
import { useLanguage } from "./useLanguage";

export const useBuildLocalizedAbsolutedUrl = () => {
  const country = useCountry();
  const language = useLanguage();

  return useCallback(
    (url: string | UrlObject) => {
      const protocol = window.location.protocol;
      const host = window.location.host;
      const localizedUrl = buildLocalizedUrl(url, country, language);
      return `${protocol}//${host}${localizedUrl}`;
    },
    [country, language]
  );
};
